import React from 'react';
import PageHeader from '../components/PageHeader';

export default function OrganizationStructure() {

  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Pages', link: '/pages' },
    { label: 'Organization Structure', active: true },
  ];

  return (
    <div>
      {/* Page Header */}
      <PageHeader title="संगठनात्मक संरचना" breadcrumbs={breadcrumbs} />

      <div className="container-xxl py-5">
        <div className="container">

          {/* Heading */}
          <div className="row mb-4">
            <div className="col-12">
              <h4 className="border-title">प्रशासनिक संरचना</h4>
              <p className="text-justify mt-3">
                अधिनियम के प्रावधानों के अनुरूप बिहार बाल अधिकार संरक्षण आयोग के
                सफल क्रियान्वयन हेतु सुदृढ़ प्रशासनिक संरचना की व्यवस्था की गई है,
                जिसकी संरचना निम्नानुसार है-
              </p>
            </div>
          </div>

          {/* Hierarchy Flow (Textual – Official Style) */}
         <div className="row mb-5">
  <div className="col-lg-8 mx-auto">

    <div className="step-card">
      <span className="step-number">1</span>
      <strong>सचिव</strong>
    </div>

    <div className="step-card">
      <span className="step-number">2</span>
      <strong>उप सचिव</strong>
    </div>

    <div className="step-card">
      <span className="step-number">3</span>
      <p className="mb-0">
        प्रशासी पदाधिकारी &nbsp;|&nbsp;
        प्रलेखन सूचना पदाधिकारी &nbsp;|&nbsp;
        बाल संरक्षण पदाधिकारी &nbsp;|&nbsp;
        अन्वेषण पदाधिकारी
      </p>
    </div>

  </div>
</div>

 <div className="row mb-4">
            <div className="col-12">
              <h4 className="border-title">आयोग में पदस्थापित प्रशासकीय पदाधिकारी एवं कर्मीगण</h4>
              
            </div>
          </div>
          {/* Officers List */}
         <div className="row g-4 py-3">

  {/* Left Column */}
  <div className="col-lg-6">
    <div className="role-panel">
      <h6>सचिव</h6>
      <p>सुश्री पिंकी कुमारी (बी.ए.एस.)</p>
    </div>

    <div className="role-panel">
      <h6>प्रशासी पदाधिकारी</h6>
      <p>श्री विनोद कुमार ठाकुर</p>
    </div>

    <div className="role-panel">
      <h6>प्रलेखन सूचना पदाधिकारी</h6>
      <p>श्रीमती पिंकी कुमारी</p>
    </div>
 <div className="role-panel">
      <h6>बाल संरक्षण पदाधिकारी</h6>
      <ul>
        <li>डॉ. रूबी कुमारी</li>
      </ul>
    </div>

    <div className="role-panel">
      <h6>अन्वेषण पदाधिकारी</h6>
      <ul>
        <li>श्रीमती अलका आम्रपाली</li>
        <li>सुश्री सीमा रहमान</li>
        <li>श्रीमती किरण बाला</li>
      </ul>
    </div>
   
  </div>

  {/* Right Column */}
  <div className="col-lg-6">
     <div className="role-panel">
      <h6>लेखपाल सह भंडारपाल</h6>
      <p>श्री रजनीश कुमार</p>
    </div>

   

    <div className="role-panel">
      <h6>निजी सहायक</h6>
      <ul>
        <li>श्री प्रेमनीति कुमार</li>
        <li>श्री मुकेश कुमार</li>
      </ul>
    </div>

    <div className="role-panel">
      <h6>डाटा एंट्री ऑपरेटर</h6>
      <ul>
        <li> श्री रोहित श्रीवास्तव</li>
        <li> श्री राज कुमार सिंह</li>
      </ul>
    </div>

    <div className="role-panel">
      <h6>आईटी कर्मी  </h6>
      <ul>
        <li>श्री जितेंद्र कुमार सिंह</li>
        <li>श्रीमती संगीता कुमारी</li>
      </ul>
    </div>
  </div>

</div>


        </div>
      </div>
    </div>
  );
}
